/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
 import { registerBlockType } from '@wordpress/blocks';
 import { __ } from '@wordpress/i18n'
 
 /**
  * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
  * All files containing `style` keyword are bundled together. The code used
  * gets applied both to the front of your site and to the editor.
  *
  * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
  *
 
 /**
  * Internal dependencies
  */
 import Edit from './edit';
 import Save from './save';
 
 registerBlockType( 'a3web-blocks/accordion', {
     apiVersion: 2,
     title: __( 'Accordéon', 'a3web-blocks' ),
     description: __(
         "Affiche un contenu sous forme d'accordéons.",
         'a3web-blocks'
     ),
     category: 'a3web-blocks',
     icon: 'testimonial',
     attributes: {
		question: {
			type: 'html',
			selector: '.a3w-accordion-question'
		},
        answer: {
			type: 'html',
			selector: '.a3w-accordion-answer'
		},
        
	},

     edit: Edit,
     save: Save,
 } )
